import Typography from "../../designComponents/Typography";
import {
  ButtonsSection,
  LabelText,
  ValueText,
} from "../Properties/Details/styles";
interface PromoteProperty {
  perDayRate: number;
  weeklyDiscountRate: number;
  monthlyDiscountRate: number;
}

interface PlatformFee {
  percentageFee: number;
  flatFee: number;
  currency: string;
}

export interface PropertyPromotion {
  promoteProperty: PromoteProperty;
  platformFee: PlatformFee;
  stripeFee?: PlatformFee;
  stripeVerification?: {
    verification: {
      flatFee: number;
      percentageFee: number;
    };
    lookup: {
      flatFee: number;
      percentageFee: number;
    };
    flatFee: number;
  };
  _id: string;
}

function ViewStripeVerificationFees({
  globalSettingsData,
  handleDelete,
}: {
  globalSettingsData?: PropertyPromotion;
  handleDelete?: (id: string) => void;
}) {
  if (!globalSettingsData) {
    return (
      <div>
        <Typography>No Settings Data</Typography>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        gap: 20,
        width: "100%",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          borderBottomWidth: 1,
          borderBottomStyle: "dashed",
          display: "flex",
          flexDirection: "row",
          width: "100%",
          paddingBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div
          style={{ display: "flex", width: "100%", flexDirection: "column" }}
        >
          <LabelText style={{ marginBottom: 8 }}>
            Stripe Verification Fee
          </LabelText>
          <ButtonsSection>
            <LabelText>Percentage Fee</LabelText>
            <ValueText>
              {globalSettingsData?.stripeVerification?.verification
                .percentageFee ?? 0}
              %
            </ValueText>
          </ButtonsSection>
          <ButtonsSection>
            <LabelText>Flat Fee Rate</LabelText>
            <ValueText>
              {" "}
              €
              {globalSettingsData?.stripeVerification?.verification?.flatFee ??
                0}
            </ValueText>
          </ButtonsSection>
        </div>
      </div>
      <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
        <LabelText style={{ marginBottom: 8 }}>Stripe Lookup Fee</LabelText>
        <ButtonsSection>
          <LabelText>Percentage Fee</LabelText>
          <ValueText>
            {globalSettingsData?.stripeVerification?.lookup.percentageFee ?? 0}%
          </ValueText>
        </ButtonsSection>
        <ButtonsSection>
          <LabelText>Flat Fee Rate</LabelText>
          <ValueText>
            {" "}
            €{globalSettingsData?.stripeVerification?.lookup.flatFee ?? 0}
          </ValueText>
        </ButtonsSection>
      </div>
      <div style={{ display: "flex", width: "100%", flexDirection: "column" }}>
        <LabelText style={{ marginBottom: 8 }}>
          Rentisity Platform Fee
        </LabelText>
        <ButtonsSection>
          <LabelText>Flat Fee</LabelText>
          <ValueText>
            {globalSettingsData?.stripeVerification?.flatFee ?? 0}%
          </ValueText>
        </ButtonsSection>
      </div>
    </div>
  );
}

export default ViewStripeVerificationFees;
